import * as React from 'react';
import { BevPageTypes } from '../BevPageTypes';
import { Button, Column } from '@codeparva/ui-components-library';
import { zoomValueToDisplay } from './generalHelpers';
import { FontAwesomeIcon } from '../../../utilities/iconLoader/FontAwesomeIcon';
import { bevLabels, buttonIconSize } from '../constants/generalConstants';
import { NormalDropDown } from '../../account/components/AccountPanel/SelectLedgerDropdown';

export const ZoomControlsContainer = ({
  zoomChangeHandler,
  zoomValue,
}: BevPageTypes.TZoomHandler) => {
  return (
    <div className="bevZoomContainer">
      <Button
        className="zoomInBtn"
        onClick={() => zoomChangeHandler('Increase')}
      >
        <FontAwesomeIcon
          iconClassName="FaPlus"
          iconContextProps={{
            className: 'has-text-secondary',
            style: {
              fontSize: buttonIconSize,
            },
          }}
        />
      </Button>
      <span>{zoomValueToDisplay(zoomValue)}</span>
      <Button
        className="zoomOutBtn"
        onClick={() => zoomChangeHandler('Decrease')}
      >
        <FontAwesomeIcon
          iconClassName="FaMinus"
          iconContextProps={{
            className: 'has-text-secondary',
            style: {
              fontSize: buttonIconSize,
            },
          }}
        />
      </Button>
    </div>
  );
};

export const BevHeader = ({
  floorsList,
  selectedFloor,
  updateFloor,
  zoomChangeHandler,
  zoomValue,
  isLoading,
}: BevPageTypes.TBevHeader) => {
  const { pageHeading, dropDownLabel } = bevLabels;

  return (
    <>
      <h4 className="bevHeading">{pageHeading}</h4>
      <Column
        display="flex"
        justifyContent="space-between"
        className="bevControls"
      >
        <div className="bevDropDown">
          <NormalDropDown
            dropDownList={floorsList}
            defaultValue={selectedFloor}
            updateSelectedValue={updateFloor}
            label={dropDownLabel}
          />
        </div>
        <ZoomControlsContainer
          zoomValue={zoomValue}
          zoomChangeHandler={zoomChangeHandler}
        />
        <div className={isLoading ? 'overlaySection' : 'is-hidden'}></div>
      </Column>
    </>
  );
};
